<template>
  <nav v-if="entries && entries.length" :class="$style.root">
    <pages-editions-parent-nav-content-component>
      <template #default>
        <pages-editions-parent-nav-edition-component
          v-for="(edition, index) in groups?.editions"
          :key="edition?.editionIndex || index"
          :index="index"
          :entry="edition"
          :activeIndex="activeIndex"
          :editionsLenght="groups?.editions?.length"
          :itemsToShow="6"
        />
      </template>

      <template #years>
        <li v-for="(edition, index) in groups?.years" :key="edition?.year || index">
          <pages-editions-parent-nav-link-component
            :entry="edition"
            :label="edition?.year"
          />
        </li>
      </template>

      <template #countries>
        <pages-editions-parent-nav-country-component
          v-for="(edition, index) in groups?.countries"
          :key="edition?.city || index"
          :entry="edition"
        />
      </template>
    </pages-editions-parent-nav-content-component>
  </nav>
</template>

<script lang="ts" setup>
const route = useRoute()

const props = defineProps({
  entries: {
    type: Array,
    required: true
  }
})

const groups = computed(() => getEditionsNavigationGroups(props.entries))

const activeIndex = computed(() => {
  return groups.value?.editions?.findIndex((edition) => {
    return edition?.slug === route?.params?.slug
  })
})
</script>

<style module>
.root {
  composes: container font-size-small from global;
}
</style>
